/**
 * Error codes that the frontend branches on
 * Add a code here when you add special handling for it; for everything else
 * use getUserMessage(error) to show the backend's userMessage.
 */
export const ErrorCodes = {
    // Auth
    UNAUTHORIZED: 'UNAUTHORIZED',
    USER_NOT_CONFIRMED: 'USER_NOT_CONFIRMED',
    HTTP_401: 'HTTP_401',

    // Resource (generic)
    RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
    RESOURCE_ALREADY_EXISTS: 'RESOURCE_ALREADY_EXISTS',

    // User role
    ROLE_MISMATCH: 'ROLE_MISMATCH',

    // Project
    LAST_MANAGER_DELETION: 'LAST_MANAGER_DELETION',
    LAST_PROJECT_MANAGER: 'LAST_PROJECT_MANAGER',
    PROJECT_ACCESS_DENIED: 'PROJECT_ACCESS_DENIED',
    PROJECT_ACCESS_FORBIDDEN: 'PROJECT_ACCESS_FORBIDDEN',
    INSUFFICIENT_PERMISSIONS: 'INSUFFICIENT_PERMISSIONS',
    USER_IS_PROJECT_MANAGER: 'USER_IS_PROJECT_MANAGER',

    // Organization
    ORGANIZATION_NAME_EXISTS: 'ORGANIZATION_NAME_EXISTS',
    USER_ORGANIZATION_EXISTS: 'USER_ORGANIZATION_EXISTS',

    // Timelog / leave
    OVERLAPPING_INTERVALS: 'OVERLAPPING_INTERVALS',
    NO_TIME_LOGS_TO_SUBMIT: 'NO_TIME_LOGS_TO_SUBMIT',
    UNFINISHED_TIME_LOGS: 'UNFINISHED_TIME_LOGS',
    DIFFERENT_LEAVE_POLICIES: 'DIFFERENT_LEAVE_POLICIES',

    // Slack / integrations
    SLACK_CHANNEL_PATTERN_ERROR: 'SLACK_CHANNEL_PATTERN_ERROR',
    SLACK_CHANNEL_NAME_EXISTS: 'SLACK_CHANNEL_NAME_EXISTS',
    SLACK_CHANNEL_RESERVED: 'SLACK_CHANNEL_RESERVED',
    TEAMS_GRAPH_API_ERROR: 'TEAMS_GRAPH_API_ERROR',
    TEAMS_PROVISIONING_FAILED: 'TEAMS_PROVISIONING_FAILED',
    TEAMS_BOT_INSTALLATION_FAILED: 'TEAMS_BOT_INSTALLATION_FAILED',
    TEAMS_BOT_NOT_INSTALLED: 'TEAMS_BOT_NOT_INSTALLED',
    TEAMS_CHANNEL_NAME_ALREADY_EXISTS: 'TEAMS_CHANNEL_NAME_ALREADY_EXISTS',

    // Evaluation
    EVALUATION_EVALUATEE_MISSING: 'EVALUATION_EVALUATEE_MISSING',
    EVALUATION_DUE_DATE_MISSING: 'EVALUATION_DUE_DATE_MISSING',
    EVALUATION_EVALUATOR_ROLE_MISSING: 'EVALUATION_EVALUATOR_ROLE_MISSING',
    EVALUATION_TOPIC_MISSING: 'EVALUATION_TOPIC_MISSING',
    EVALUATION_EVALUATOR_MISSING: 'EVALUATION_EVALUATOR_MISSING',

    // Subscription
    SUBSCRIPTION_FEATURE_UNAVAILABLE: 'SUBSCRIPTION_FEATURE_UNAVAILABLE',
    SUBSCRIPTION_UPGRADE_REQUIRED: 'SUBSCRIPTION_UPGRADE_REQUIRED',
} as const;

export type ErrorCode = typeof ErrorCodes[keyof typeof ErrorCodes];
